let initialized = false;

//export function initAdminScripts() {
export function initAdminScripts(force = false) {  
  /*if (initialized) return;
  initialized = true;*/
  if (initialized && !force) return;

  initialized = true;


/* Tool Tip: the message above an input.
   ALWAYS shown while it is invalid (red, see app-forms.css), and also while the input has focus
   when main.js formTooltipMode = 'focusAndInvalid'.
   Works for every input, also ones that appear later (form windows, new pages). */
if (!window.__saTooltipReady) {
  window.__saTooltipReady = true;

  // The tooltip is next to the input, or (FormField with an icon) just outside its input-group.
  // Inputs and groups with data-tooltip="..." get one made for them.
  const findTooltip = function (input) {
    const found = input.closest(".sa-field")?.querySelector(":scope > .custom-tooltip")
      || input.parentElement.querySelector(".custom-tooltip")
      || input.closest(".input-group")?.parentElement.querySelector(":scope > .custom-tooltip");
    if (found) return found;

    const text = input.getAttribute("data-tooltip");
    if (!text) return null;

    // A group (e.g. the radio buttons) holds its own tooltip; an input puts it in its parent
    const holder = input.tagName === "INPUT" ? input.parentElement : input;
    if (getComputedStyle(holder).position === "static") holder.style.position = "relative";

    const tooltip = document.createElement("div");
    tooltip.className = "custom-tooltip";
    tooltip.textContent = text;
    const arrow = document.createElement("span");
    arrow.className = "tooltip-arrow";
    tooltip.appendChild(arrow);
    holder.appendChild(tooltip);
    return tooltip;
  };

  // Above the input, lined up with its right edge
  const positionTooltip = function (input, tooltip) {
    const holder = tooltip.offsetParent || input.parentElement;
    const inputRect = input.getBoundingClientRect();
    const holderRect = holder.getBoundingClientRect();
    tooltip.style.top = (inputRect.top - holderRect.top - tooltip.offsetHeight - 4) + "px";
    // Never start left of the field (small fields like a switch: the tooltip runs to the right)
    tooltip.style.left = Math.max(0, inputRect.right - holderRect.left - tooltip.offsetWidth) + "px";
  };

  // Invalid = the input (or the dropdown inside it) has is-invalid
  const isInvalid = function (input) {
    return input.classList.contains("is-invalid") || !!input.querySelector(".is-invalid");
  };
  const hasFocus = function (input) {
    return input.contains(document.activeElement);
  };
  // main.js formTooltipMode: 'focusAndInvalid' = also show while the box has focus
  const showOnFocus = function () {
    return window.formTooltipMode === "focusAndInvalid";
  };

  // Show or hide one input's tooltip (only changes the class when needed)
  const updateTooltip = function (input) {
    const tooltip = findTooltip(input);
    if (!tooltip) return;
    if (isInvalid(input) || (showOnFocus() && hasFocus(input))) {
      if (!tooltip.classList.contains("show")) tooltip.classList.add("show");
      positionTooltip(input, tooltip);
    } else if (tooltip.classList.contains("show")) {
      tooltip.classList.remove("show");
    }
  };

  // Focus and blur
  document.addEventListener("focusin", function (e) {
    const input = e.target.closest?.(".custom-tooltip-input");
    if (input) updateTooltip(input);
  });
  document.addEventListener("focusout", function (e) {
    const input = e.target.closest?.(".custom-tooltip-input");
    // Wait a moment: focus may be moving inside the same field (e.g. a dropdown)
    if (input) setTimeout(function () { updateTooltip(input); }, 0);
  });

  // Marked valid / invalid by $validateForm (is-valid / is-invalid added or removed)
  new MutationObserver(function (changes) {
    const inputs = new Set();
    changes.forEach(function (change) {
      // A tooltip's own show/hide is not a field change: ignore it (else it loops forever)
      if (change.target.closest?.(".custom-tooltip")) return;
      const input = change.target.closest?.(".custom-tooltip-input");
      if (input) inputs.add(input);
    });
    inputs.forEach(updateTooltip);
  }).observe(document.body, { attributes: true, attributeFilter: ["class"], subtree: true });

  // Reposition the visible tooltips when the window size changes
  window.addEventListener("resize", function () {
    document.querySelectorAll(".custom-tooltip-input").forEach(function (input) {
      const tooltip = findTooltip(input);
      if (tooltip && tooltip.classList.contains("show")) positionTooltip(input, tooltip);
    });
  });
}
/* End Tool Tip */


// Universal function to toggle plus/minus
function toggleIcon(link, expanding) {
  if (!link) return;

  const emIcon = link.querySelector(".collapse-sign em");
  const iIcon  = link.querySelector("em.fa");

  function updateIcon(icon) {
    if (!icon) return;

    if (expanding) {
      icon.classList.remove("fa-plus-square-o");
      icon.classList.add("fa-minus-square-o");
    } else {
      icon.classList.remove("fa-minus-square-o");
      icon.classList.add("fa-plus-square-o");
    }
  }

  updateIcon(emIcon);
  updateIcon(iIcon);
}
// End Universal function to toggle plus/minus


// Handle all collapsible links - For switching menu plus & minus icon
document.querySelectorAll('.nav-link[data-bs-toggle="collapse"]').forEach(function (link) {

  const targetSelector = link.getAttribute("href") || link.getAttribute("data-bs-target");
  if (!targetSelector) return;

  const collapseEl = document.querySelector(targetSelector);
  if (!collapseEl) return;

  function handleCollapseEvent(e) {
    // Only run for the collapse element itself (ignore nested collapses)
    if (e.target !== collapseEl) return;

    const expanding = e.type === "show.bs.collapse";

    // Call your plain JS toggle function
    toggleIcon(link, expanding);

    // Group headers are not marked active (the current page and its groups are coloured by CSS)
    if (expanding) {
      link.classList.add("text-white");
    } else {
      link.classList.remove("bg-primary");
    }
  }

  collapseEl.addEventListener("show.bs.collapse", handleCollapseEvent);
  collapseEl.addEventListener("hide.bs.collapse", handleCollapseEvent);

});
// End Handle all collapsible links


// Fullscreen toggle script
const fullscreenBtn = document.getElementById("fullscreenBtn");

if (fullscreenBtn) {
  fullscreenBtn.addEventListener("click", function () {
    // Toggle active class
    this.classList.toggle("active");

    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch(err => {
        console.error("Error attempting to enable fullscreen:", err);
      });
    } else {
      document.exitFullscreen().catch(err => {
        console.error("Error attempting to exit fullscreen:", err);
      });
    }
  });
}
// End Fullscreen toggle script


// Sidebar collapse button toggle active
const sidebarToggle = document.getElementById("sidebarCollapseArrow");
const sidebar = document.getElementById("sidebar");

if (sidebarToggle && sidebar) {

  const arrowIcon = sidebarToggle.querySelector("i");

  sidebarToggle.addEventListener("click", function (e) {
    e.preventDefault();

    // Toggle sidebar collapsed class
    sidebar.classList.toggle("sidebar-collapsed");

    // Toggle active class on arrow button
    this.classList.toggle("active");

    // Toggle icon
    if (arrowIcon) {
      if (arrowIcon.classList.contains("fa-arrow-circle-left")) {
        arrowIcon.classList.remove("fa-arrow-circle-left");
        arrowIcon.classList.add("fa-arrow-circle-right");
      } else {
        arrowIcon.classList.remove("fa-arrow-circle-right");
        arrowIcon.classList.add("fa-arrow-circle-left");
      }
    }

    // Move arrow depending on sidebar width
    this.style.left = sidebar.classList.contains("sidebar-collapsed")
      ? "0px"
      : "200px";
  });
}
// Second collapse button
const sidebarCollapseBtn = document.getElementById("sidebarCollapseBtn");

if (sidebarCollapseBtn && sidebar) {
  sidebarCollapseBtn.addEventListener("click", function () {
    this.classList.toggle("active"); // toggle active class
    sidebar.classList.toggle("sidebar-collapsed"); // keep existing sidebar logic
    
    // Call existing function if it exists
    if (typeof arrowSideBar === "function") {
      arrowSideBar();
    }
  });
}
// End Sidebar collapse button toggle active


// arrowSideBar
function arrowSideBar() {
  const sidebarToggle = document.getElementById("sidebarCollapseArrow");
  const sidebar = document.getElementById("sidebar");

  if (!sidebarToggle || !sidebar) return;

  const arrowIcon = sidebarToggle.querySelector("i");

  // Toggle icon
  if (arrowIcon) {
    if (arrowIcon.classList.contains("fa-arrow-circle-left")) {
      arrowIcon.classList.remove("fa-arrow-circle-left");
      arrowIcon.classList.add("fa-arrow-circle-right");
    } else {
      arrowIcon.classList.remove("fa-arrow-circle-right");
      arrowIcon.classList.add("fa-arrow-circle-left");
    }
  }

  // Move arrow depending on sidebar width
  if (sidebar.classList.contains("sidebar-collapsed")) {
    sidebarToggle.style.left = "0px";
  } else {
    sidebarToggle.style.left = "200px"; // sidebar width
  }
}
// End arrowSideBar


// Function to update arrow visibility
function updateArrowVisibility() {
  const sidebarArrow = document.getElementById("sidebarCollapseArrow");
  if (!sidebarArrow) return;

  if (document.body.classList.contains("menu-top-active")) {
    sidebarArrow.style.display = "none";   // hide arrow for top menu
  } else {
    sidebarArrow.style.display = "block";  // show arrow for sidebar
  }
}
// End Function to update arrow visibility



// Gear badge at top right
const gearBadge = document.getElementById("gearBadge");
const gearPanel = document.getElementById("gearPanel");
const gearIcon = gearBadge ? gearBadge.querySelector("i") : null;

if (gearBadge && gearPanel && gearIcon) {

  // Click on gear badge
  gearBadge.addEventListener("click", function (e) {
    e.stopPropagation(); // Prevent document click from hiding

    gearPanel.classList.toggle("show");

    if (gearPanel.classList.contains("show")) {
      // Panel opened → show spinning X
      gearIcon.classList.remove("fa-cogs", "fa-spin");
      gearIcon.classList.add("fa-times", "fa-spin-reverse-x");
    } else {
      // Panel closed → back to gear
      gearIcon.classList.remove("fa-times", "fa-spin-reverse-x");
      gearIcon.classList.add("fa-cogs", "fa-spin");
    }
  });

  // Click anywhere outside panel → hide panel & revert icon
  document.addEventListener("click", function (e) {
    if (!(e.target instanceof Element)) return;
    const clickedInside =
      e.target.closest("#gearBadge") || e.target.closest("#gearPanel");

    if (!clickedInside && gearPanel.classList.contains("show")) {
      gearPanel.classList.remove("show");

      gearIcon.classList.remove("fa-times", "fa-spin-reverse-x");
      gearIcon.classList.add("fa-cogs", "fa-spin");
    }
  });
}
// End gear badge at top right



// buildTopMenu when switching to top menu
function buildTopMenu() {
  const sidebar = document.getElementById("sidebar");
  const menuList = document.getElementById("horizontalMenuList");

  if (!sidebar || !menuList) return;

  // Clear existing top menu
  menuList.innerHTML = "";

  // Select top-level list items inside sidebar
  const liItems = sidebar.querySelectorAll(":scope > .offcanvas-body > .nav > li");

  liItems.forEach(li => {
    const link = li.querySelector(":scope > a.nav-link");
    if (!link) return;

    const collapse = li.querySelector(":scope > .collapse");

    // Create new dropdown container for top menu
    const dropdownLi = document.createElement("li");
    dropdownLi.classList.add("nav-item");

    // Clone link
    const topLink = link.cloneNode(true);

    // Remove text-white class
    topLink.classList.remove("text-white");

    // Set attributes
    topLink.setAttribute("href", collapse ? "#" : link.getAttribute("href"));
    topLink.setAttribute("role", "button");
    topLink.setAttribute("aria-expanded", "false");

    // Responsive behavior
    if (window.innerWidth < 992) {
      topLink.classList.add("nav-link", "dropdown-toggle");
      // Remove icons or collapse signs
      topLink.querySelectorAll("em.fa, b.collapse-sign").forEach(el => el.remove());
    } else {
      topLink.classList.add(
        "nav-link",
        "dropdown-toggle",
        "d-flex",
        "flex-column",
        "align-items-center",
        "text-center"
      );
      topLink.querySelectorAll("em.fa, i.fa:not(.menu-lock), b.collapse-sign, .dropdown-arrow").forEach(el => el.remove());

      // Prepend first icon if exists
      const icon = link.querySelector("i");
      if (icon) topLink.prepend(icon.cloneNode(true));

      // Optional: add down arrow later if needed
      // const arrowSpan = document.createElement("span");
      // arrowSpan.classList.add("dropdown-arrow", "mt-1");
      // arrowSpan.textContent = "▾";
      // topLink.appendChild(arrowSpan);
    }

    // Full name on hover (long names are cut with "…")
    topLink.title = topLink.textContent.replace(/\s+/g, " ").trim();

    // Append link to li
    dropdownLi.appendChild(topLink);

    // Create dropdown arrow element
    const arrow = document.createElement("span");
    arrow.className = "dropdown-arrow";
    arrow.textContent = "▾";
    arrow.style.opacity = collapse ? "1" : "0";
    arrow.style.lineHeight = "0.3";
    arrow.style.fontSize = "0.7em";

    if (collapse) {
      // Submenu exists → build dropdown
      dropdownLi.classList.add("dropdown");
      topLink.classList.add("dropdown-toggle");
      topLink.setAttribute("data-bs-toggle", "dropdown");

      // Append submenu using existing buildDropdown function
      const subUl = collapse.querySelector("ul");
      if (subUl) {
        dropdownLi.appendChild(buildDropdown(subUl));
      }
    } else {
      // No submenu → remove dropdown behavior
      topLink.classList.remove("dropdown-toggle");
      topLink.removeAttribute("data-bs-toggle");

      // Append arrow manually
      topLink.appendChild(arrow);
    }

    // Append li to top menu
    menuList.appendChild(dropdownLi);
  });
}
// End buildTopMenu when switching to top menu


// buildDropdown when switching to top menu
function buildDropdown(ul) {
  if (!ul) return null;

  // Create new dropdown menu
  const menu = document.createElement("ul");
  menu.className = "dropdown-menu";

  // Iterate through children li elements
  ul.querySelectorAll(":scope > li").forEach(li => {
    const link = li.querySelector(":scope > a.nav-link");
    if (!link) return;

    // Clone link
    const newLink = link.cloneNode(true);

    // Remove classes and add dropdown-item
    newLink.classList.remove("text-white");
    newLink.classList.add("dropdown-item");

    // Remove data-bs-toggle attribute
    newLink.removeAttribute("data-bs-toggle");

    // Remove icons and collapse signs recursively (keep the 🔒 padlock)
    newLink.querySelectorAll("em.fa, i.fa:not(.menu-lock), b.collapse-sign").forEach(el => el.remove());

    // Full name on hover (long names are cut with "…")
    newLink.title = newLink.textContent.trim();

    const collapse = li.querySelector(":scope > .collapse");

    if (collapse) {
      // Submenu exists → create dropdown-submenu
      const submenuLi = document.createElement("li");
      submenuLi.classList.add("dropdown-submenu");

      // The › at the end comes from the .dropdown-submenu CSS, so no extra arrow here
      submenuLi.appendChild(newLink);

      // Recursively build nested submenu
      const subUl = collapse.querySelector("ul");
      if (subUl) {
        const nestedMenu = buildDropdown(subUl);
        if (nestedMenu) submenuLi.appendChild(nestedMenu);
      }

      menu.appendChild(submenuLi);
    } else {
      // No submenu → just append the link
      const liContainer = document.createElement("li");
      liContainer.appendChild(newLink);
      menu.appendChild(liContainer);
    }
  });

  return menu;
}
// End buildDropdown when switching to top menu


// addTopLinkBorders
function addTopLinkBorders() {
  const links = document.querySelectorAll("#horizontalMenuList > .nav-item > .nav-link");

  links.forEach(link => {
    // Skip submenu items (dropdown-item)
    if (!link.classList.contains("dropdown-item")) {
      link.style.borderStyle = "solid";
      link.style.borderLeft = "1px solid var(--sa-tmenu-divider, grey)";
      link.style.borderTop = "none";
      link.style.borderBottom = "none";
      link.style.borderRadius = "0";
      link.style.padding = "10px 14px";
      link.style.display = "inline-block";
      link.style.boxSizing = "border-box";
    }
  });
}
// End addTopLinkBorders


// Top menu "More": items that don't fit on the bar move into a More dropdown (computers only)
function fitTopMenuItems() {
  const menuList = document.getElementById("horizontalMenuList");
  if (!menuList) return;

  // Already fitted before (e.g. called again): rebuild the full list first
  if (menuList.querySelector(":scope > .top-menu-more")) {
    buildTopMenu();
    addTopLinkBorders();
  }

  // Phones: the top menu is a vertical list, everything fits
  if (window.innerWidth < 992) return;

  const items = Array.from(menuList.querySelectorAll(":scope > .nav-item"));
  if (items.length === 0) return;

  const listRight = menuList.getBoundingClientRect().right;

  // Everything fits: nothing to do
  if (items[items.length - 1].getBoundingClientRect().right <= listRight) return;

  // Add "More" at the end
  const moreLi = document.createElement("li");
  moreLi.className = "nav-item dropdown top-menu-more";
  moreLi.innerHTML =
    '<a class="nav-link dropdown-toggle d-flex flex-column align-items-center text-center" href="#" role="button" aria-expanded="false" title="More">' +
      '<i class="fa fa-lg fa-fw fa-ellipsis-h"></i><span class="menu-item-parent">More</span>' +
    '</a>' +
    '<ul class="dropdown-menu"></ul>';
  menuList.appendChild(moreLi);

  const moreMenu = moreLi.querySelector(":scope > .dropdown-menu");

  // Items that don't fit next to "More"
  const limit = listRight - moreLi.offsetWidth;
  const overflowing = items.filter(li => li.getBoundingClientRect().right > limit);

  overflowing.forEach(li => {
    const link = li.querySelector(":scope > a.nav-link");
    const subMenu = li.querySelector(":scope > .dropdown-menu");
    if (!link) return;

    // Bar link → dropdown item (keep level-toggle so the active / close-menu code still works)
    const keepToggle = link.classList.contains("level-toggle");
    link.removeAttribute("style");
    link.removeAttribute("data-bs-toggle");
    link.className = keepToggle ? "dropdown-item level-toggle" : "dropdown-item";
    link.querySelectorAll("i.fa:not(.menu-lock), .dropdown-arrow").forEach(el => el.remove());

    const newLi = document.createElement("li");
    newLi.appendChild(link);
    if (subMenu) {
      newLi.classList.add("dropdown-submenu");
      newLi.appendChild(subMenu);   // its sub-menu comes along
    }
    moreMenu.appendChild(newLi);
    li.remove();
  });

  // Give "More" the same look as the other bar items
  addTopLinkBorders();
}
// End Top menu "More"


// Move the user menu (picture + dropdown) from the sidebar to the top bar
function moveUserMenuToTop() {
  const userMenu = document.querySelector("#userMenu > .dropdown");
  const target = document.querySelector(".userMenuWhenSwitchedToTop");
  if (!userMenu || !target || target.contains(userMenu)) return;

  target.appendChild(userMenu);
  userMenu.classList.add("user-menu-top");
  // Open the dropdown towards the left, so it stays on screen
  userMenu.querySelector(":scope > .dropdown-menu")?.classList.add("dropdown-menu-end");
}

// Put the user menu back in the sidebar
function restoreUserMenuToSidebar() {
  const userMenu = document.querySelector(".userMenuWhenSwitchedToTop > .dropdown");
  const home = document.getElementById("userMenu");
  if (!userMenu || !home) return;

  home.appendChild(userMenu);
  userMenu.classList.remove("user-menu-top");
  userMenu.querySelector(":scope > .dropdown-menu")?.classList.remove("dropdown-menu-end");
}
// End move user menu

// Convert menu to Top Menu
const menuOnTopBtn = document.querySelector("#gearPanel #menuOnTop");

if (menuOnTopBtn) {
  menuOnTopBtn.addEventListener("click", function (e) {
    e.stopPropagation();

    const sidebar = document.getElementById("sidebar");
    const topMenu = document.getElementById("topHorizontalMenu");
    const menuList = document.getElementById("horizontalMenuList");
    const sidebarArrow = document.getElementById("sidebarCollapseArrow");

    if (!sidebar || !topMenu || !menuList || !sidebarArrow) return;

    if (topMenu.classList.contains("d-none")) {
      // 👉 SWITCH TO TOP MENU
      topMenu.classList.remove("d-none");
      sidebar.classList.add("d-none");
      document.body.classList.add("menu-top-active");

      sidebarArrow.classList.add("d-none");
      sidebarArrow.classList.remove("d-lg-inline");

      // ✅ SET menuMode
      localStorage.setItem("menuMode", "top");

      // Clear menu list
      menuList.innerHTML = "";

      // Call top-level items
      buildTopMenu();
      addTopLinkBorders();

      // ✅ MOVE USER MENU TO TOP
      if (typeof moveUserMenuToTop === "function") moveUserMenuToTop();

    } else {
      // SWITCH BACK TO SIDEBAR MENU
      topMenu.classList.add("d-none");
      sidebar.classList.remove("d-none");
      document.body.classList.remove("menu-top-active");

      // Show/hide sidebar arrow based on window width
      if (window.innerWidth >= 992) {
        sidebarArrow.classList.remove("d-none");
        sidebarArrow.classList.add("d-lg-inline");
      } else {
        sidebarArrow.classList.add("d-none");
        sidebarArrow.classList.remove("d-lg-inline");
      }

      // ✅ SET menuMode
      localStorage.setItem("menuMode", "side");

      // ✅ RESTORE USER MENU TO SIDEBAR
      if (typeof restoreUserMenuToSidebar === "function") restoreUserMenuToSidebar();
    }

    // Adjust footer & arrow visibility
    if (typeof adjustFooter === "function") adjustFooter();
    if (typeof updateArrowVisibility === "function") updateArrowVisibility();
  });
}
// End Convert menu to Top Menu


// Rebuild top menu as you resize screen when top menu is active
window.addEventListener("resize", function () {
  // 🔒 Only rebuild when top menu is active
  if (document.body.classList.contains("menu-top-active")) {
    if (typeof buildTopMenu === "function") buildTopMenu();
    if (typeof addTopLinkBorders === "function") addTopLinkBorders();
  }
});
// End rebuild top menu as you resize screen when top menu is active



// Close menu if the link does not have dropdown
document.addEventListener("click", function (e) {
  if (!(e.target instanceof Element)) return;
  const target = e.target.closest(".level-toggle");
  if (!target) return;

  // Only apply when top menu is active
  if (!document.body.classList.contains("menu-top-active")) return;

  // Check if the parent li has a dropdown-menu
  const parentLi = target.closest("li");
  const hasDropdown = parentLi ? parentLi.querySelector("ul.dropdown-menu") : null;

  if (hasDropdown) {
    // 👇 Parent item → just allow submenu toggle
    e.preventDefault();
    e.stopPropagation();
    return;
  }

  const collapseDuration = 350;

  // Disable hover temporarily
  const topMenu = document.getElementById("topHorizontalMenu");
  if (topMenu) topMenu.classList.add("disable-hover");

  // Collapse all parent collapses (top menu only)
  let parentCollapse = target.closest(".collapse");
  while (parentCollapse) {
    const bsCollapse = bootstrap.Collapse.getInstance(parentCollapse) ||
                       new bootstrap.Collapse(parentCollapse, { toggle: false });
    bsCollapse.hide();

    // Move up to next parent collapse
    parentCollapse = parentCollapse.parentElement.closest(".collapse");
  }

  // Restore hover after delay
  setTimeout(() => {
    if (topMenu) topMenu.classList.remove("disable-hover");
  }, collapseDuration + 50);
});
// End Close menu if the link does not have drop down


// Restore menu mode from previous session
if (localStorage.getItem("menuMode") === "top") {
  document.body.classList.add("menu-top-active");
}
// End Restore menu mode from previous session


// If body already says "top menu active", sync the UI
if (document.body.classList.contains("menu-top-active")) {
  const topMenu = document.getElementById("topHorizontalMenu");
  const gearPanelBtn = document.querySelector("#gearPanel #menuOnTop");

  if (topMenu && topMenu.classList.contains("d-none") && gearPanelBtn) {
    // Simulate click on gear panel button
    gearPanelBtn.click();
  }
}
// End If body already says "top menu active", sync the UI


// Remove active from all sidebar links & top menu links
document.addEventListener("click", function (e) {
  if (!(e.target instanceof Element)) return;
  const link = e.target.closest(".level-toggle");
  if (!link) return;

  // Check if parent li has a dropdown menu
  const parentLi = link.closest("li");
  const hasDropdown = parentLi ? parentLi.querySelector(".dropdown-menu") : null;

  if (hasDropdown) {
    // Parent dropdown → don’t navigate
    e.preventDefault();
    e.stopPropagation();
    return;
  }

  // Remove active from all sidebar and top menu links
  document.querySelectorAll("#sidebar .nav-link, #topHorizontalMenu .dropdown-item")
    .forEach(el => el.classList.remove("active"));

  // Add active to clicked link
  link.classList.add("active");
});
// End Remove active from all sidebar links & top menu links



// Fixing and unfixing the header & footer: done in Breadcrumbs.vue (applyFixedBars)



// For Top Menu Hovering & Unhovering

// Helper function to add/remove 'link-hover' to parent dropdown toggles
function toggleParentHover(element, add) {
  let parentDropdowns = element.closest("#topHorizontalMenu")?.querySelectorAll(".nav-item.dropdown");
  if (!parentDropdowns) return;

  let current = element.closest(".nav-item.dropdown");
  while (current) {
    const toggleLink = current.querySelector(":scope > a.nav-link.dropdown-toggle");
    if (toggleLink) {
      if (add) toggleLink.classList.add("link-hover");
      else toggleLink.classList.remove("link-hover");
    }
    // Move up to next parent dropdown
    current = current.parentElement.closest(".nav-item.dropdown");
  }
}

// Hover on any top menu link
document.addEventListener("mouseenter", function (e) {
  if (!(e.target instanceof Element)) return;
  const link = e.target.closest("#topHorizontalMenu a.nav-link");
  if (!link) return;
  link.classList.add("link-hover");
  toggleParentHover(link, true);
}, true); // use capture to mimic jQuery mouseenter

document.addEventListener("mouseleave", function (e) {
  if (!(e.target instanceof Element)) return;
  const link = e.target.closest("#topHorizontalMenu a.nav-link");
  if (!link) return;
  link.classList.remove("link-hover");
  toggleParentHover(link, false);
}, true);

// Hover on any dropdown menu
document.addEventListener("mouseenter", function (e) {
  if (!(e.target instanceof Element)) return;
  const dropdown = e.target.closest("#topHorizontalMenu .dropdown-menu");
  if (!dropdown) return;
  const parentLink = dropdown.closest(".nav-item.dropdown")?.querySelector(":scope > a.nav-link.dropdown-toggle");
  if (parentLink) parentLink.classList.add("link-hover");
}, true);

document.addEventListener("mouseleave", function (e) {
  if (!(e.target instanceof Element)) return;
  const dropdown = e.target.closest("#topHorizontalMenu .dropdown-menu");
  if (!dropdown) return;
  const parentLink = dropdown.closest(".nav-item.dropdown")?.querySelector(":scope > a.nav-link.dropdown-toggle");
  if (parentLink) parentLink.classList.remove("link-hover");
}, true);

// End For Top Menu Hovering & Unhovering


// Top menu: keep dropdowns on screen
// A sub-menu that would go past the right edge of the screen opens to the left instead.
// The position is calculated, not tried out, so the menu never jumps while you hover.
document.addEventListener("mouseenter", function (e) {
  if (!(e.target instanceof Element)) return;

  const screenWidth = document.documentElement.clientWidth;   // width without the scroll bar

  // First dropdown under a top bar item
  if (e.target.matches("#horizontalMenuList > .nav-item.dropdown")) {
    const topItem = e.target;
    const menu = topItem.querySelector(":scope > .dropdown-menu");
    if (!menu) return;
    const width = menu.offsetWidth || 240;
    const fitsRight = topItem.getBoundingClientRect().left + width <= screenWidth;
    topItem.classList.toggle("align-right", !fitsRight);
    return;
  }

  // Sub-menus (level 2, 3, 4 ...)
  if (!e.target.matches("#topHorizontalMenu .dropdown-submenu")) return;
  const item = e.target;
  const menu = item.querySelector(":scope > .dropdown-menu");
  if (!menu) return;

  const width = menu.offsetWidth || 240;
  const itemRect = item.getBoundingClientRect();
  const fitsRight = itemRect.right + width <= screenWidth;
  const fitsLeft = itemRect.left - width >= 0;

  // Once a level went left, deeper levels keep going left (if there is room)
  const parentWentLeft = !!item.parentElement.closest(".dropdown-submenu.open-left");
  let openLeft = parentWentLeft ? fitsLeft : !fitsRight;
  if (openLeft && !fitsLeft) openLeft = false;   // no room on either side: stay on the right

  item.classList.toggle("open-left", openLeft);
}, true);
// End Top menu: keep dropdowns on screen


// Moving UserMenu from sidebar to Top Menu at top far right
if (document.body.classList.contains("menu-top-active")) {
  if (typeof moveUserMenuToTop === "function") {
    moveUserMenuToTop();
  }
}
// End Moving UserMenu from sidebar to Top Menu at top far right


// For Bootstrap table – Toggling plus & minus icon

// Handle click on expand cell
document.addEventListener("click", function (e) {
  if (!(e.target instanceof Element)) return;
  const cell = e.target.closest(".expand-cell");
  if (!cell) return;

  const targetSelector = cell.getAttribute("data-bs-target");
  if (!targetSelector) return;

  const target = document.querySelector(targetSelector);
  if (!target) return;

  // Close other open rows
  document.querySelectorAll(".table-collapse.show")
    .forEach(el => {
      if (el !== target) {
        const instance = bootstrap.Collapse.getOrCreateInstance(el);
        instance.hide();
      }
    });
});

// When collapse is shown
document.addEventListener("show.bs.collapse", function (e) {
  if (!(e.target instanceof Element)) return;
  const collapseEl = e.target.closest(".table-collapse");
  if (!collapseEl) return;

  const id = collapseEl.id;
  const td = document.querySelector(`td[data-bs-target="#${id}"]`);
  if (!td) return;

  td.setAttribute("aria-expanded", "true");
  td.querySelectorAll(".expand-icon").forEach(icon => {
    icon.classList.remove("fa-plus", "text-success");
    icon.classList.add("fa-minus", "text-danger");
  });
});

// When collapse is hidden
document.addEventListener("hide.bs.collapse", function (e) {
  if (!(e.target instanceof Element)) return;
  const collapseEl = e.target.closest(".table-collapse");
  if (!collapseEl) return;

  const id = collapseEl.id;
  const td = document.querySelector(`td[data-bs-target="#${id}"]`);
  if (!td) return;

  td.setAttribute("aria-expanded", "false");
  td.querySelectorAll(".expand-icon").forEach(icon => {
    icon.classList.remove("fa-minus", "text-danger");
    icon.classList.add("fa-plus", "text-success");
  });
});
// End For Bootstrap table – Toggling plus & minus icon


// Close mobile sidebar when clicking item without dropdown
document.addEventListener("click", function (e) {
  if (!(e.target instanceof Element)) return;
  const link = e.target.closest("#sidebar .nav-link");
  if (!link) return;

  // Skip if link has dropdown/collapse
  if (link.getAttribute("data-bs-toggle") === "collapse") return;

  // Only for mobile (Bootstrap lg breakpoint or smaller)
  if (window.innerWidth < 992) {
    const sidebarEl = document.getElementById("sidebar");
    if (!sidebarEl) return;

    const offcanvasInstance = bootstrap.Offcanvas.getInstance(sidebarEl);
    if (offcanvasInstance) offcanvasInstance.hide();
  }
});
// End Close mobile sidebar when clicking item without dropdown


// Sidebar: clicking a top-level link with no sub-menu (e.g. Dashboard, CRUD Test) closes the open menus
document.addEventListener("click", function (e) {
  if (!(e.target instanceof Element)) return;

  // Only the main sidebar items, not links inside a sub-menu
  const link = e.target.closest("#sidebar .offcanvas-body > .nav > li > .nav-link");
  if (!link) return;

  // Menus with a sub-menu are handled by Bootstrap (data-bs-parent)
  if (link.getAttribute("data-bs-toggle") === "collapse") return;

  // Top menu mode has its own closing code
  if (document.body.classList.contains("menu-top-active")) return;

  document.querySelectorAll("#sidebar .collapse.show").forEach(function (el) {
    bootstrap.Collapse.getOrCreateInstance(el, { toggle: false }).hide();
  });
});
// End Sidebar: clicking a top-level link closes the open menus



/* Switch back to default theme */
const defaultThemeBtn = document.getElementById("defaultThemeBtn");
if (defaultThemeBtn) {
  defaultThemeBtn.addEventListener("click", function () {
    document.documentElement.removeAttribute("data-theme"); // removes the data-theme attribute
    localStorage.setItem("theme", "default"); // save preference
  });
}

/* Switch to smart theme */
const smartThemeBtn = document.getElementById("smartThemeBtn");
if (smartThemeBtn) {
  smartThemeBtn.addEventListener("click", function () {
    document.documentElement.setAttribute("data-theme", "smart"); // Add the data-theme attribute
    localStorage.setItem("theme", "smart"); // save preference
  });
}


/* Switch to dark theme */
const darkThemeBtn = document.getElementById("darkThemeBtn");
if (darkThemeBtn) {
  darkThemeBtn.addEventListener("click", function () {
    document.documentElement.setAttribute("data-theme", "dark");
    localStorage.setItem("theme", "dark"); // save preference
  });
}
/* End Switch to dark theme */

/* Switch to red theme */
const redThemeBtn = document.getElementById("redThemeBtn");
if (redThemeBtn) {
  redThemeBtn.addEventListener("click", function () {
    document.documentElement.setAttribute("data-theme", "red");
    localStorage.setItem("theme", "red"); // save preference
  });
}
/* End Switch to red theme */


/* Switch to blue theme */
const blueThemeBtn = document.getElementById("blueThemeBtn");
if (blueThemeBtn) {
  blueThemeBtn.addEventListener("click", function () {
    document.documentElement.setAttribute("data-theme", "blue");
    localStorage.setItem("theme", "blue"); // save preference
  });
}
/* End Switch to blue theme */

/* Switch to dark red theme */
const darkredThemeBtn = document.getElementById("darkredThemeBtn");
if (darkredThemeBtn) {
  darkredThemeBtn.addEventListener("click", function () {
    document.documentElement.setAttribute("data-theme", "darkred");
    localStorage.setItem("theme", "darkred"); // save preference
  });
}
/* End Switch to dark red theme */


/* Switch to smartglass theme */
const smartglassThemeBtn = document.getElementById("smartglassThemeBtn");
if (smartglassThemeBtn) {
  smartglassThemeBtn.addEventListener("click", function () {
    document.documentElement.setAttribute("data-theme", "saglass");
    localStorage.setItem("theme", "saglass"); // save preference
    document.body.classList.remove("dark", "red", "smart");
    document.body.classList.add("saglass");
  });
}
/* End Switch to smartglass theme */

/* Switch to smartglass red theme (uses the same "saglass" body class for the background image) */
const smartglassRedThemeBtn = document.getElementById("smartglassRedThemeBtn");
if (smartglassRedThemeBtn) {
  smartglassRedThemeBtn.addEventListener("click", function () {
    document.documentElement.setAttribute("data-theme", "saglassred");
    localStorage.setItem("theme", "saglassred"); // save preference
    document.body.classList.remove("dark", "red", "smart");
    document.body.classList.add("saglass");
  });
}
/* End Switch to smartglass red theme */

/* Switch to smartglass blue theme (uses the same "saglass" body class for the background image) */
const smartglassBlueThemeBtn = document.getElementById("smartglassBlueThemeBtn");
if (smartglassBlueThemeBtn) {
  smartglassBlueThemeBtn.addEventListener("click", function () {
    document.documentElement.setAttribute("data-theme", "saglassblue");
    localStorage.setItem("theme", "saglassblue"); // save preference
    document.body.classList.remove("dark", "red", "smart");
    document.body.classList.add("saglass");
  });
}
/* End Switch to smartglass blue theme */

/* Switch to smartglass green theme (uses the same "saglass" body class for the background image) */
const smartglassGreenThemeBtn = document.getElementById("smartglassGreenThemeBtn");
if (smartglassGreenThemeBtn) {
  smartglassGreenThemeBtn.addEventListener("click", function () {
    document.documentElement.setAttribute("data-theme", "saglassgreen");
    localStorage.setItem("theme", "saglassgreen"); // save preference
    document.body.classList.remove("dark", "red", "smart");
    document.body.classList.add("saglass");
  });
}
/* End Switch to smartglass green theme */

/* Switch to smartglass black theme (uses the same "saglass" body class for the background image) */
const smartglassBlackThemeBtn = document.getElementById("smartglassBlackThemeBtn");
if (smartglassBlackThemeBtn) {
  smartglassBlackThemeBtn.addEventListener("click", function () {
    document.documentElement.setAttribute("data-theme", "saglassblack");
    localStorage.setItem("theme", "saglassblack"); // save preference
    document.body.classList.remove("dark", "red", "smart");
    document.body.classList.add("saglass");
  });
}
/* End Switch to smartglass black theme */

/* Switch to smartglass yellow theme (uses the same "saglass" body class for the background image) */
const smartglassYellowThemeBtn = document.getElementById("smartglassYellowThemeBtn");
if (smartglassYellowThemeBtn) {
  smartglassYellowThemeBtn.addEventListener("click", function () {
    document.documentElement.setAttribute("data-theme", "saglassyellow");
    localStorage.setItem("theme", "saglassyellow"); // save preference
    document.body.classList.remove("dark", "red", "smart");
    document.body.classList.add("saglass");
  });
}
/* End Switch to smartglass yellow theme */

/* Switch to smartglass white theme (uses the same "saglass" body class for the background image) */
const smartglassWhiteThemeBtn = document.getElementById("smartglassWhiteThemeBtn");
if (smartglassWhiteThemeBtn) {
  smartglassWhiteThemeBtn.addEventListener("click", function () {
    document.documentElement.setAttribute("data-theme", "saglasswhite");
    localStorage.setItem("theme", "saglasswhite"); // save preference
    document.body.classList.remove("dark", "red", "smart");
    document.body.classList.add("saglass");
  });
}
/* End Switch to smartglass white theme */

/* Switch to smartglass sky blue theme (uses the same "saglass" body class for the background image) */
const smartglassSkyblueThemeBtn = document.getElementById("smartglassSkyblueThemeBtn");
if (smartglassSkyblueThemeBtn) {
  smartglassSkyblueThemeBtn.addEventListener("click", function () {
    document.documentElement.setAttribute("data-theme", "saglassskyblue");
    localStorage.setItem("theme", "saglassskyblue"); // save preference
    document.body.classList.remove("dark", "red", "smart");
    document.body.classList.add("saglass");
  });
}
/* End Switch to smartglass sky blue theme */

/* Switch to smartglass grey theme (uses the same "saglass" body class for the background image) */
const smartglassGreyThemeBtn = document.getElementById("smartglassGreyThemeBtn");
if (smartglassGreyThemeBtn) {
  smartglassGreyThemeBtn.addEventListener("click", function () {
    document.documentElement.setAttribute("data-theme", "saglassgrey");
    localStorage.setItem("theme", "saglassgrey"); // save preference
    document.body.classList.remove("dark", "red", "smart");
    document.body.classList.add("saglass");
  });
}
/* End Switch to smartglass grey theme */

/* Switch to smartglass grey white theme (uses the same "saglass" body class for the background image) */
const smartglassGreywhiteThemeBtn = document.getElementById("smartglassGreywhiteThemeBtn");
if (smartglassGreywhiteThemeBtn) {
  smartglassGreywhiteThemeBtn.addEventListener("click", function () {
    document.documentElement.setAttribute("data-theme", "saglassgreywhite");
    localStorage.setItem("theme", "saglassgreywhite"); // save preference
    document.body.classList.remove("dark", "red", "smart");
    document.body.classList.add("saglass");
  });
}
/* End Switch to smartglass grey white theme */

/* Switch to classic white theme */
const classicwhiteThemeBtn = document.getElementById("classicwhiteThemeBtn");
if (classicwhiteThemeBtn) {
  classicwhiteThemeBtn.addEventListener("click", function () {
    document.documentElement.setAttribute("data-theme", "classicwhite");
    localStorage.setItem("theme", "classicwhite"); // save preference
    document.body.classList.remove("saglass");     // no glass background
  });
}
/* End Switch to classic white theme */

/* Switch to grey white theme */
const greywhiteThemeBtn = document.getElementById("greywhiteThemeBtn");
if (greywhiteThemeBtn) {
  greywhiteThemeBtn.addEventListener("click", function () {
    document.documentElement.setAttribute("data-theme", "greywhite");
    localStorage.setItem("theme", "greywhite"); // save preference
    document.body.classList.remove("saglass");  // no glass background
  });
}
/* End Switch to grey white theme */

/* Browser bar colour (<meta name="theme-color">) follows the active skin.
   Uses --sa-theme-color if a theme file sets it, otherwise the theme's main dark colour */
function updateMetaThemeColor() {
  const meta = document.querySelector('meta[name="theme-color"]');
  if (!meta) return;

  const css = getComputedStyle(document.documentElement);
  // Glass skins have a see-through top bar (rgba): phones would show it as solid white,
  // so use the skin's page colour instead
  const topbar = css.getPropertyValue("--sa-topbar-grad-start").trim();
  const isSeeThrough = /^(rgba|hsla)\(|transparent/i.test(topbar);

  const color = css.getPropertyValue("--sa-theme-color").trim()
    || (isSeeThrough ? "" : topbar)
    || css.getPropertyValue("--sa-body-color").trim()
    || "#0d6efd";

  meta.setAttribute("content", color);

  // Inside the Android WebView app: ask the app to colour its top & bottom bars
  // (Chrome uses the meta tag above; a WebView ignores it)
  if (window.AndroidApp) {
    if (typeof window.AndroidApp.setBarColor === "function") {
      window.AndroidApp.setBarColor(color);      // Android Studio (Java/Kotlin) bridge
    } else if (typeof window.AndroidApp.postMessage === "function") {
      window.AndroidApp.postMessage(color);      // Flutter JavaScriptChannel named "AndroidApp"
    }
  }
}

// Runs every time a skin button (or the restore below) changes data-theme
new MutationObserver(updateMetaThemeColor)
  .observe(document.documentElement, { attributes: true, attributeFilter: ["data-theme"] });

// Default skin (no data-theme) on first load
updateMetaThemeColor();
/* End Browser bar colour follows the active skin */

/* Restore saved theme on page load */
const savedTheme = localStorage.getItem("theme");

if (savedTheme) {
  switch (savedTheme) {
    case "smart":
      document.documentElement.setAttribute("data-theme", "smart");
      break;
    case "dark":
      document.documentElement.setAttribute("data-theme", "dark");
      break;
    case "red":
      document.documentElement.setAttribute("data-theme", "red");
      break;
    case "saglassgreywhite":
      document.documentElement.setAttribute("data-theme", "saglassgreywhite");
      document.body.classList.remove("dark", "red", "smart");
      document.body.classList.add("saglass");
      break;
    case "saglassgrey":
      document.documentElement.setAttribute("data-theme", "saglassgrey");
      document.body.classList.remove("dark", "red", "smart");
      document.body.classList.add("saglass");
      break;
    case "saglassskyblue":
      document.documentElement.setAttribute("data-theme", "saglassskyblue");
      document.body.classList.remove("dark", "red", "smart");
      document.body.classList.add("saglass");
      break;
    case "saglasswhite":
      document.documentElement.setAttribute("data-theme", "saglasswhite");
      document.body.classList.remove("dark", "red", "smart");
      document.body.classList.add("saglass");
      break;
    case "saglassyellow":
      document.documentElement.setAttribute("data-theme", "saglassyellow");
      document.body.classList.remove("dark", "red", "smart");
      document.body.classList.add("saglass");
      break;
    case "saglassblack":
      document.documentElement.setAttribute("data-theme", "saglassblack");
      document.body.classList.remove("dark", "red", "smart");
      document.body.classList.add("saglass");
      break;
    case "saglassgreen":
      document.documentElement.setAttribute("data-theme", "saglassgreen");
      document.body.classList.remove("dark", "red", "smart");
      document.body.classList.add("saglass");
      break;
    case "saglassblue":
      document.documentElement.setAttribute("data-theme", "saglassblue");
      document.body.classList.remove("dark", "red", "smart");
      document.body.classList.add("saglass");
      break;
    case "saglassred":
      document.documentElement.setAttribute("data-theme", "saglassred");
      document.body.classList.remove("dark", "red", "smart");
      document.body.classList.add("saglass");
      break;
    case "saglass":
      document.documentElement.setAttribute("data-theme", "saglass");
      document.body.classList.remove("dark", "red", "smart");
      document.body.classList.add("saglass");
      break;
    case "darkred":
      document.documentElement.setAttribute("data-theme", "darkred");
      break;
    case "blue":
      document.documentElement.setAttribute("data-theme", "blue");
      break;
    case "classicwhite":
      document.documentElement.setAttribute("data-theme", "classicwhite");
      break;
    case "greywhite":
      document.documentElement.setAttribute("data-theme", "greywhite");
      break;
    default:
      document.documentElement.removeAttribute("data-theme"); // default light
      break;
  }
} else {
  document.documentElement.removeAttribute("data-theme"); // default light
}
/* End Restore saved theme */



/* Collapse (hide/show table), Fullscreen, & Delete (remove table) */

// Helper: slideToggle animation
function slideToggle(el, duration = 200) {
  if (!el) return;
  if (window.getComputedStyle(el).display === "none") {
    el.style.removeProperty("display");
    let display = window.getComputedStyle(el).display;
    if (display === "none") display = "block";
    el.style.display = "block";
    const height = el.offsetHeight;
    el.style.height = "0";
    el.style.overflow = "hidden";
    el.offsetHeight; // force repaint
    el.style.transition = `height ${duration}ms`;
    el.style.height = height + "px";
    setTimeout(() => {
      el.style.removeProperty("height");
      el.style.removeProperty("overflow");
      el.style.removeProperty("transition");
    }, duration);
  } else {
    const height = el.offsetHeight;
    el.style.height = height + "px";
    el.style.overflow = "hidden";
    el.offsetHeight; // force repaint
    el.style.transition = `height ${duration}ms`;
    el.style.height = "0";
    setTimeout(() => {
      el.style.display = "none";
      el.style.removeProperty("height");
      el.style.removeProperty("overflow");
      el.style.removeProperty("transition");
    }, duration);
  }
}

// Collapse (hide/show table)
document.addEventListener("click", function (e) {
  if (!(e.target instanceof Element)) return;
  const btn = e.target.closest(".btn-collapse");
  if (!btn) return;

  const card = btn.closest(".card");
  if (!card) return;

  const table = card.querySelector(".table-responsive");
  slideToggle(table, 200);

  const icon = btn.querySelector("i");
  if (icon) {
    icon.classList.toggle("fa-minus");
    icon.classList.toggle("fa-plus");
  }
});

// Fullscreen
document.addEventListener("click", function (e) {
  if (!(e.target instanceof Element)) return;
  const btn = e.target.closest(".btn-fullscreen");
  if (!btn) return;

  const card = btn.closest(".card");
  if (!card) return;

  card.classList.toggle("table-fullscreen");

  const icon = btn.querySelector("i");
  if (icon) {
    icon.classList.toggle("fa-expand");
    icon.classList.toggle("fa-compress");
  }
});

// Delete table
document.addEventListener("click", function (e) {
  if (!(e.target instanceof Element)) return;
  const btn = e.target.closest(".btn-delete");
  if (!btn) return;

  if (!confirm("Delete this table?")) return;

  const card = btn.closest(".card");
  if (!card) return;

  card.style.transition = "opacity 200ms";
  card.style.opacity = "0";
  setTimeout(() => {
    card.remove();
  }, 200);
});

/* End Collapse (hide/show body), Fullscreen, & Delete (remove table) */




/* For Custom message, notification, and Task Box */
const dropdownBtn = document.getElementById("dropdownBtn");
const customDropdown = document.getElementById("customDropdown");

if (dropdownBtn && customDropdown) {
  // Move the little arrow so it points at the middle of the button (any screen size)
  function pointCaretAtButton() {
    const caret = customDropdown.querySelector(".custom-caret-up");
    if (!caret || customDropdown.classList.contains("d-none")) return;
    const btn = dropdownBtn.getBoundingClientRect();
    const box = customDropdown.getBoundingClientRect();
    // the box is still turning in (flip animation), so work from its centre and real width
    const boxLeft = box.left + box.width / 2 - customDropdown.offsetWidth / 2;
    caret.style.left = (btn.left + btn.width / 2 - boxLeft) + "px";
  }
  window.addEventListener("resize", pointCaretAtButton);

  // Toggle dropdown on button click
  dropdownBtn.addEventListener("click", (e) => {
    e.stopPropagation(); // prevent document click from hiding
    customDropdown.classList.toggle("d-none");
    pointCaretAtButton();
  });

  // Close dropdown if clicking outside
  document.addEventListener("click", (e) => {
    if (!customDropdown.contains(e.target) && !dropdownBtn.contains(e.target)) {
      customDropdown.classList.add("d-none");
    }
  });
}
/* End For Custom message, notification, and Task Box */


/*Global definitions*/
//---------------------------------------------------
   //Continue with global definitions here. Go to custom.js JQuery 
   //and convert to vanilla
//---------------------------------------------------
/*End Global definitions*/


  // PASTE ALL YOUR JS CODE HERE
}

//End export function initAdminScripts() {